import { resolveRichText } from '@vibesites/runtime';

/**
 * Merge property + selected hyperlocal query item so richtext field tokens
 * (data-field="h1_title", etc.) resolve from the Hyperlocal Queries collection
 * in preview and live hyperlocal routes.
 */
export function resolveHyperlocalRichText(
  html: string | null | undefined,
  property: Record<string, unknown> | null | undefined,
  hyperlocal: Record<string, unknown> | undefined,
): string {
  if (!html) return '';
  const merged = {
    ...(property as Record<string, unknown>),
    ...(hyperlocal || {}),
  } as Record<string, unknown>;
  return resolveRichText(html, merged as Record<string, any>);
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Wrap plain text from hyperlocal in a single paragraph for richtext defaults. */
export function hyperlocalParagraph(text: string | undefined): string | undefined {
  if (text == null || text === '') return undefined;
  return `<p>${escapeHtml(text)}</p>`;
}

/** page_copy may be HTML or plain text from the CMS */
export function hyperlocalPageCopyFallback(pageCopy: string | undefined): string | undefined {
  if (pageCopy == null || pageCopy === '') return undefined;
  return pageCopy.includes('<') ? pageCopy : hyperlocalParagraph(pageCopy);
}
